import { useEffect, useState } from "react";
import KhoiPhucPhieuBiXoaApi from "service/khoiPhucPhieuBiXoaApi";

// Backend quyết định phiếu nào hiện nút khôi phục (loại phiếu, phiếu người dùng tự xóa, hợp đồng chưa bị xóa...);
// chưa có kết quả của đúng danh sách đang hiển thị thì chưa hiện nút
export const useCoTheKhoiPhuc = (list, quyenKhoiPhuc) => {
  const [ketQua, setKetQua] = useState({ list: null, ids: new Set() });

  useEffect(() => {
    const ids = (list || []).map((x) => x.ThuChiID);
    if (!quyenKhoiPhuc || ids.length === 0) {
      setKetQua({ list, ids: new Set() });
      return;
    }
    let conHieuLuc = true;
    const ghi = (dsId) => conHieuLuc && setKetQua({ list, ids: new Set(dsId) });
    KhoiPhucPhieuBiXoaApi.phieuCoTheKhoiPhuc(ids)
      .then((response) => ghi(Array.isArray(response.data) ? response.data : []))
      .catch(() => ghi([]));
    return () => {
      conHieuLuc = false;
    };
  }, [list, quyenKhoiPhuc]);

  return (item) => ketQua.list === list && ketQua.ids.has(item.ThuChiID);
};
